import { render } from "./EditDomain.vue?vue&type=template&id=ffa87e8a&ts=true"
import script from "./EditDomain.vue?vue&type=script&lang=ts"
export * from "./EditDomain.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__